import * as Geo from "tslib/geo";


export class ScanViewZoomLevel {
    scale = 1;  // Scale coefficient compared to the original scan
    zoomLevel = 0;  // 0 - original, -1 - 2x, -2 - 4x, etc.
    zoomedSize!: Geo.Size;
};

